import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CustomerSurveyAnswer, CustomerSurveyQuestion } from '@coin/shared/customer-survey/util';
import { CustomerSurveyComponent } from '../customer-survey/customer-survey.component';

@Component({
  selector: 'coin-customer-survey-question',
  templateUrl: './customer-survey-question.component.html',
  styleUrls: ['./customer-survey-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomerSurveyQuestionComponent {
  protected surveyComponent = inject(CustomerSurveyComponent);

  question = input.required<CustomerSurveyQuestion>();
  index = input.required<number>();

  isExpanded = computed(() => this.surveyComponent.expandedPanelIndex() === this.index());
  selectedAnswer = computed(() =>
    this.question()?.answers?.find(answer => answer.id === this.question().selectedAnswerId)
  );
  isLastElement = computed(() => !!this.selectedAnswer()?.linkedSurveyResultId);

  public onAnswerToggle(isSelected: boolean, toggledAnswer: CustomerSurveyAnswer): void {
    if (!isSelected) return;

    this.question().answers = this.question().answers.map(answer => ({
      ...answer,
      isSelected: answer.id === toggledAnswer.id
    }));
    this.question().selectedAnswerId = toggledAnswer.id;
    this.surveyComponent.onAnswerToggle(toggledAnswer);
  }

  protected updatePanelIndex(): void {
    this.surveyComponent.expandedPanelIndex.set(this.index());
  }

  protected resetPanelIndexIfNecessary() {
    if (this.isExpanded()) {
      this.surveyComponent.expandedPanelIndex.set(-1);
    }
  }

  protected openNextPanel(event: PointerEvent) {
    event.stopPropagation();
    if (this.isLastElement()) {
      this.surveyComponent.expandedPanelIndex.set(-1);
      this.surveyComponent.completeSurvey.emit();
    } else {
      this.surveyComponent.expandedPanelIndex.set(this.index() + 1);
    }
  }
}
